<div class="container">
  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div *ngIf="dataGateData && !loading && !error">
    <div *ngIf="dataGateData.success">
      <form [formGroup]="dynamicForm" class="mt-6">
          <!-- Akt Fields -->
          <ng-container *ngIf="hasVisibleAktFields()">
            <h2 class="fw-bold">{{ 'DataGate.AktInformation' | translate }}</h2>
            <ng-container *ngFor="let field of dataGateData.result.aktFields">
              <div *ngIf="field.displayForExistingAkt !== false">
              <!-- Dropdown fields (boolean, optionset, lookup) -->
              <ng-container *ngIf="field.type === 'boolean' || field.type === 'optionset' || field.type === 'lookup'">
                <app-form-input-dropdown
                  [label]="field.spaLabel"
                  [values]="field.options"
                  [formName]="dynamicForm"
                  [control]="getFormControl(field.fieldName)"
                  [name]="field.fieldName"
                  [dynamicFormSettings]="true"
                  [placeholder]="'General.InputSelectPlaceholder' | translate"
                ></app-form-input-dropdown>
              </ng-container>

              <!-- Text fields (text, email, tel, url) -->
              <ng-container *ngIf="field.type === 'text' || field.type === 'email' || field.type === 'tel' || field.type === 'url'">
                <app-form-input-text
                  [type]="field.type"
                  [placeholder]="field.spaLabel"
                  [required]="field.required"
                  [name]="field.fieldName"
                  [label]="field.spaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControl(field.fieldName)"
                  [maxLength]="field.maxLength ?? undefined"
                ></app-form-input-text>
              </ng-container>

              <!-- Currency fields -->
              <ng-container *ngIf="field.type === 'currency'">
                <app-form-input-currency
                  [label]="field.spaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControl(field.fieldName)"
                  [name]="field.fieldName"
                  [required]="field.required"
                  [min]="field.min ?? ''"
                  [max]="field.max ?? ''"
                  [currency]="field.currency ?? []"
                ></app-form-input-currency>
              </ng-container>

              <!-- Date fields -->
              <ng-container *ngIf="field.type === 'date'">
                <app-form-input-date
                  [label]="field.spaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControl(field.fieldName)"
                  [name]="field.fieldName"
                  [required]="field.required"
                ></app-form-input-date>
              </ng-container>
              </div>
            </ng-container>
          </ng-container>

          <!-- Contact Fields -->
          <ng-container *ngIf="hasVisibleContactFields()" class="mt-6">
            <h2 class="mt-5 mt-lg-6 fw-bold">{{ 'DataGate.ContactInformation' | translate }}</h2>
            <ng-container *ngFor="let field of dataGateData.result.contactFields">
              <div>
              <!-- Dropdown fields (boolean, optionset, lookup) -->
              <ng-container *ngIf="field.type === 'boolean' || field.type === 'optionset' || field.type === 'lookup'">
                <app-form-input-dropdown
                  [label]="field.spaLabel"
                  [values]="field.options"
                  [formName]="dynamicForm"
                  [control]="getFormControl(field.fieldName)"
                  [name]="field.fieldName"
                  [dynamicFormSettings]="true"
                  [placeholder]="'General.InputSelectPlaceholder' | translate"
                ></app-form-input-dropdown>
              </ng-container>

              <!-- Text fields (text, email, tel, url) -->
              <ng-container *ngIf="field.type === 'text' || field.type === 'email' || field.type === 'tel' || field.type === 'url'">
                <app-form-input-text
                  [type]="field.type"
                  [placeholder]="field.spaLabel"
                  [required]="field.required"
                  [name]="field.fieldName"
                  [label]="field.spaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControl(field.fieldName)"
                  [maxLength]="field.maxLength ?? undefined"
                ></app-form-input-text>
              </ng-container>

              <!-- Currency fields -->
              <ng-container *ngIf="field.type === 'currency'">
                <app-form-input-currency
                  [label]="field.spaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControl(field.fieldName)"
                  [name]="field.fieldName"
                  [required]="field.required"
                  [min]="field.min ?? ''"
                  [max]="field.max ?? ''"
                  [currency]="field.currency ?? []"
                ></app-form-input-currency>
              </ng-container>

              <!-- Date fields -->
              <ng-container *ngIf="field.type === 'date'">
                <app-form-input-date
                  [label]="field.spaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControl(field.fieldName)"
                  [name]="field.fieldName"
                  [required]="field.required"
                ></app-form-input-date>
              </ng-container>
              </div>
            </ng-container>
          </ng-container>

          <!-- Streitwerts Section -->
          <ng-container *ngIf="dataGateData.result.streitwertsToUpdate.length > 0 || dataGateData.result.streitwertsToCreate.length > 0">
            <h2 class="fw-bold mt-6 mb-4">{{ 'DataGate.Streitwerts' | translate }}</h2>

            <!-- Existing Streitwerts -->
            <div *ngFor="let row of valueInDisuputeRows; let i = index" class="dispute-box-container">
              <app-dispute-box
                *ngIf="isDisputeBoxReady(i)"
                [index]="i"
                [sectionId]="row.id"
                [fields]="getFieldsForDisputeBox(row)"
                [enableMultipleProducts]="row.isNew"
                [productSelectionOptions]="row.isNew ? dataGateData.result.streitwertsToCreate : []"
                [projectSettings]="projectSettings"
                [existingFiles]="[]"
                [sessionToken]="sessionToken"
                [projectShortName]="projectShortName"
                [tokenIdentifier]="tokenIdentifier"
                [dynamicForm]="dynamicForm"
                [title]="row.isNew ? 'Anspruch' : getDatagateDisputeBoxTitle(row)"
                [isDatagateMode]="true"
                [valueInDispute]="row"
                [first]="i === 0"
                [shouldCollapse]="(collapseDisputeBoxes[i] && !row.isNew) || false"
                [disableFileGet]="true"
                [hideDeleteIcon]="!row.isNew"
                (removeItem)="removeValueInDispute($event)"
                (disputeBoxValid)="onDisputeBoxValidationChange($event, i)">
              </app-dispute-box>
              <!-- Loading placeholder while disputebox is initializing -->
              <div *ngIf="!isDisputeBoxReady(i)" class="dispute-box-loading">
                <div class="text-center p-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div class="mt-2">{{ 'General.Loading' | translate }}</div>
                </div>
              </div>
            </div>

            <!-- Add New Streitwert Button -->
            <div *ngIf="activeState()" class="mt-3 text-center">
              <div class="btn btn-sm btn-primary rounded-3" (click)="addValueInDispute()">
                <i class="fa-solid fa-circle-plus pe-2"></i>
                {{ 'StepValueInDispute.ButtonAddDispute' | translate }}
              </div>
            </div>
          </ng-container>



      </form>

      <div class="mt-6 mt-xxl-4 text-end">
        <app-form-button-submit
          *ngIf="!loading && !loadingRedirect"
          [label]="'DataGate.ButtonSubmit' | translate"
          [icon]="'angle-right'"
          [active]="isFormValid()"
          (click)="clickOnNextButton()"
        ></app-form-button-submit>
      </div>
    </div>

    <div *ngIf="!dataGateData.success" class="alert alert-danger"
         [innerHTML]="'DataGate.LoadingError' | translate" >
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<ng-template #deleteConfirmModal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'General.ConfirmationDelete' | translate }}</h4>
  </div>
  <div class="modal-body">
    <p>{{ 'General.DeleteValueInDisputeConfirmation' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelDelete()">{{ 'General.ConfirmationAbbort' | translate }}</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">{{ 'General.ConfirmationDelete' | translate }}</button>
  </div>
</ng-template>
